module.exports = {
  apis: {
    startupService: {
      name: 'startup-service',
      host: 'https://is3jijdx64.execute-api.us-east-1.amazonaws.com/prod/public/graphql'
    }
  }
}
